import { StoreRepository } from "../../../../data/repository/store/StoreRepository";
import { Message } from "../../../model/Auth";
import { ResponseState, State } from "../../../model/ResponseState";
import { Store } from "../../../model/Store";

export interface CreateStoreUseCase {
  invoke: (store: Store) => Promise<ResponseState<Message>>;
}

export class CreateStoreUseCaseImpl implements CreateStoreUseCase {
  private repo: StoreRepository;

  constructor(repo: StoreRepository) {
    this.repo = repo;
  }

  async invoke(store: Store): Promise<ResponseState<Message>> {
    try {
      let response = await this.repo.createStore(store);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
